export default {
  dashboard: "Dashboard",
  users: "Utenti",
  adminActivities: "Attività",
  adminStructures: "Strutture",
  activities: "Attività",
  myHouses: "Le mie strutture",
  bookings: "Prenotazioni",
  partnersAndHosts: "Venditori e host",
  wallet: "Portafoglio",
  points: "Punti",
  settings: "Impostazioni",
  helpSupport: "Aiuto e supporto",
  devices: "Gestione dispositivi",
  devicesList: "Dispositivi",
  devicesPresets: "Preset dispositivo",
  devicesCarousel: "Carosello",
  devicesStatistics: "Statistiche",
  readers: "Lettori",
  supportTickets: "Supporto utenti",
  supportTicketsList: "Ticket partner",
  supportChats: "Chat clienti",
  adminPayments: "Contabilità",
  adminPaymentsEvents: "Eventi economici",
  adminPaymentsExternal: "Pagamenti esterni",
  adminPaymentsSettlements: "Liquidazioni",
  adminNotifications: "Notifiche",
  adminProtocols: "Protocolli",
  adminAgentTranscripts: "Trascrizioni vocali",
  adminNotificationsOpen_one: "{{count}} notifica aperta",
  adminNotificationsOpen_other: "{{count}} notifiche aperte",
  bookingsNew_one: "{{count}} nuova prenotazione",
  bookingsNew_other: "{{count}} nuove prenotazioni",
  completeProfile: "Completa il tuo profilo",
  completeProfileTitle: "Profilo legale incompleto",
  completeProfileDescription:
    "Finché il profilo legale non è completo, le tue attività non possono essere mostrate ai clienti nel catalogo.",
  completeProfileLink: "Completa il profilo →",
  logout: "Esci",
  impersonating: "Impersonando",
  stopImpersonating: "Termina impersonificazione",
  logoutWhileImpersonatingTitle: "Stai impersonando {{name}}",
  logoutWhileImpersonatingMessage:
    "Vuoi terminare l’impersonificazione o uscire?",
  groups: {
    overview: "Panoramica",
    management: "Gestione",
    operations: "Operatività",
    finance: "Finanza",
    account: "Account",
  },
  theme: {
    switchToLight: "Passa al tema chiaro",
    switchToDark: "Passa al tema scuro",
  },
  search: "Cerca…",
  openMenu: "Apri menu",
  closeMenu: "Chiudi menu",
  breadcrumb: "Percorso di navigazione",
} as const;
